import _defineProperty from "@babel/runtime/helpers/defineProperty";
import Immutable from 'immutable';

const createEnum = items => {
  class Enum extends Immutable.Record(items) {
    constructor(...args) {
      super(...args);

      _defineProperty(this, "items", () => [...this.toSeq().values()]);
    }

  }

  return new Enum();
};

export default createEnum;